export default "__VITE_ASSET__CIvC3Q9J__"